<template>
    <div>
        <div class="page-btns-box">
            <el-button
                type="primary"
                icon="el-icon-circle-plus-outline"
                @click="goAddOrEdit"
                v-if="$utils.have('/help/entry/create')"
                size="small"
                >创建词条</el-button
            >
        </div>
        <div  style="overflow: auto;">
            <table ref="table" border="0" class="draggable-table">
                <thead>
                    <tr>
                        <th>
                            <div class="cell">排序</div>
                        </th>
                        <th>
                            <div class="cell">序号</div>
                        </th>
                        <th>
                            <div class="cell">状态</div>
                        </th>
                        <th>
                            <div class="cell">ID</div>
                        </th>
                        <th>
                            <div class="cell">名称</div>
                        </th>
                        <th>
                            <div class="cell">所属菜单</div>
                        </th>
                        <th>
                            <div class="cell">创建时间</div>
                        </th>
                        <th>
                            <div class="cell">操作</div>
                        </th>
                    </tr>
                </thead>
                <vuedraggable v-model="dataList"  tag="tbody" handle=".handle"  @change="updateWordSort">                
                    <template v-if="dataList && dataList.length > 0">
                        <tr v-for="t in dataList" :key="t.id">
                            <td>
                                <div class="cell handle">                                
                                    <i class="el-icon-sort"></i>
                                </div>
                            </td>
                            <td>
                                <div class="cell">
                                    {{ t.sort }}
                                </div>
                            </td>
                            <td>
                                <div class="cell">
                                    <el-tag size="mini" :type="t.status == -1 ? 'danger' : 'success'">{{ t.status == -1 ?  "隐藏" : "展示"}}</el-tag>
                                </div>
                            </td>
                            <td>
                                <div class="cell">
                                    {{ t.id }}
                                </div>
                            </td>
                            <td>
                                <div class="cell">
                                    <el-tooltip class="item" effect="dark" :content="t.title" placement="top">
                                        <span>{{ t.titleStr }}</span>
                                    </el-tooltip>
                                </div>
                            </td>
                            <td>
                                <div class="cell">
                                    {{ t.titleName }}
                                </div>
                            </td>
                            <td>
                                <div class="cell">
                                    {{ t.createTime }}
                                </div>
                            </td>
                            <td>
                                <div class="cell"> 
                                    <el-button
                                        type="text"
                                        size="small"
                                        icon="el-icon-s-management"
                                        @click="goAddOrEdit('edit', t.id)"
                                        v-if="$utils.have('/help/entry/update')"
                                        >管理</el-button>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <tr v-else class="ignore">
                        <td colspan="9">
                            <div class="empty">暂无数据</div>
                        </td>
                    </tr>
                </vuedraggable>
            </table>
        </div>
         <div class="group MT20">
            <el-button @click="goBack">返回</el-button>
        </div>
    </div>
</template>

<script>
import vuedraggable from 'vuedraggable';

export default {
    components: {
        vuedraggable
    },
    data(){
        const {pId, id, parentTitle, title} = this.$route.params;
        return {
            listLoading: false,
            addWordVisible: false,
            dataList: null,
            paramsInfo: {firstMenuId:  pId || id, secondMenuId: pId ? id : 0, parentTitle, title},
            redirect: this.$route.query.redirect ,
        }
    },
    created(){
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            const data = {...this.paramsInfo};
            this.$request({
                url: "/help/entry/list",
                method: "POST",
                data
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        const {parentTitle, title} = this.$route.params;
                        this.dataList = result;                        
                        this.dataList.forEach(i =>{
                            i.titleStr = i.title.slice(0, 40);
                            if(i.title && i.title.length > 40){
                                i.titleStr += '...'
                            }
                            i.parentTitle = parentTitle;
                            i.titleName = title;
                        })
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //查看
        goAddOrEdit(type, id) {
            const params = Object.assign({}, this.paramsInfo);
            let name = 'helpMange-add-mangeMenu'
            if(type == 'edit') {
                name = 'helpMange-edit-mangeMenu'
                params.wordId = id;
            }
            this.$router.push({name, params})
        },
        updateWordSort(){
            let data = this.dataList.map((i, idx)=>{   
                i.sort = idx + 1;          
                return {
                    sort: i.sort,
                    id: i.id
                }
            })
            this.$request({
                url: "/help/entry/updateSort",
                method: "POST",
                data
            }).then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1 ) {
                        this.$message.success("操作成功");
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.draggable-table {
    table-layout: auto;
    border-collapse: collapse;
    width: 100%;
    min-width: 710px;
    border: 1px solid #ebeef5;

    .empty {
        text-align: center;
        line-height: 20px;
        color: #909399;
    }

    th,
    td {
        position: relative;
        padding: 10px 0;
        text-align: left;
        border: 1px solid #ebeef5;
        border-top: 0;
        border-left: 0;
        vertical-align: middle;
        box-sizing: border-box;

        .cell {
            padding: 0 10px;
            width: 100%;
            white-space: normal;
            word-break: break-all;
            line-height: 23px;
            overflow: hidden;
            box-sizing: border-box;

            &.handle {
                cursor: move;
            }
        }
    }

    th {
        background-color: #f5f7fa;
        font-size: 13px;
        color: #909399;
        font-weight: 700;
        .cell{
            white-space: nowrap;
        }
    }

    td {
        font-size: 13px;
        color: #606266;
    }

    tr:hover td {
        background-color: #f5f7fa;
    }
}
</style>